import React from "react";

import {NotFoundComponent} from './NotFound.component';

export const NotFound = NotFoundComponent;